import React from "react";
import { TransactionRuleCondition } from "@common/types/transactionRule";
import { getSubaccountDisplayName } from "@design-system/Subaccount/utils";
import { Subaccount } from "@common/types/subaccount";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { RuleTagRow } from "../RuleTagRow";
import { getDirectionLabel } from "../ruleTagUtils";

interface Props {
    condition: TransactionRuleCondition;
}

export const RuleSubaccountsCondition: React.FC<Props> = ({ condition }) => {
    const ids = (
        Array.isArray(condition.value) ? condition.value : [condition.value]
    ) as string[];
    const accounts = useFinancialAccounts();
    const subaccountNames = accounts
        .flatMap((account) => account.subaccounts)
        .filter(
            (subaccount): subaccount is Subaccount =>
                !!subaccount && ids.includes(subaccount.id),
        )
        .map((subaccount) => getSubaccountDisplayName(subaccount));

    if (!subaccountNames.length) {
        return null;
    }

    const label = getDirectionLabel("Subaccount", condition.transferDirection);

    return (
        <RuleTagRow label={label} type="condition" values={subaccountNames} />
    );
};
